import axios from "axios";
import { API_URL } from "./constants";

const api = axios.create({ baseURL: API_URL });

// Adjunta el token JWT en cada request si existe
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
